module.exports = __webpack_public_path__ + "img/sankaku_45_red.8698cbec.png";